import { HttpInterceptorFn } from '@angular/common/http';
import { retry, throwError, timer } from 'rxjs';
import { REINTENTO, REINTENTO_DELAY_MS, REINTENTO_INTENTOS } from './reintento-context';
import { esErrorDeRed } from '../utils/errores/errores-manejados';

/**
 * Reintenta la request ante un fallo de red (status 0), solo si lleva REINTENTO en su contexto.
 *
 * IMPORTANTE: debe ir ÚLTIMO en withInterceptors([...]) (el más interno). Así:
 *  - reintenta solo la llamada al backend, con la URL ya parcheada y el token ya agregado;
 *  - el SpinnerInterceptor (externo) mantiene el spinner durante el reintento y su
 *    finalize corre una sola vez;
 *  - el ErrorHandlerInterceptor solo recibe el error si fallan todos los intentos.
 *
 * Cualquier otro status (400, 401, 404, 500, 503...) NO se reintenta: se propaga tal cual.
 */
export const ReintentoInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.context.get(REINTENTO)) return next(req);

  return next(req).pipe(
    retry({
      count: REINTENTO_INTENTOS,
      delay: (error) =>
        esErrorDeRed(error)
          ? timer(REINTENTO_DELAY_MS)
          : throwError(() => error),
    })
  );
};